document.addEventListener("DOMContentLoaded", () => {
  const coverageCheckerAvailabilityPopupContainer = document.getElementById("coverage-checker-availability-popup-container");
  const coverageCheckerAvailabilityPopup = document.getElementById("coverage-checker-availability-popup");
  const availabilityPopupCloseButton = document.getElementById("coverage-checker-availability-popup-close-button");

  availabilityPopupCloseButton.addEventListener("click", () => {
    coverageCheckerAvailabilityPopupContainer.style.display = "none";
    coverageCheckerAvailabilityPopup.style.display = "none";
  });

  coverageCheckerAvailabilityPopupContainer.addEventListener('click', () => {
    coverageCheckerAvailabilityPopupContainer.style.display = "none";
    coverageCheckerAvailabilityPopup.style.display = "none";
  })

  coverageCheckerAvailabilityPopup.addEventListener('click', (event) => {
    event.stopPropagation();
  });
});

const checkCoverage = async (address, submitButton) => {
  const addressDisplay = document.getElementById("coverage-checker-availability-popup-form-address-text");
  const coverageCheckerAvailabilityPopupContainer = document.getElementById("coverage-checker-availability-popup-container");
  const coverageCheckerAvailabilityPopup = document.getElementById("coverage-checker-availability-popup");

  if (address.length < 5) {
    Toastify({
      text: "Please enter a valid zip code or address",
      duration: 3000,
      newWindow: true,
      gravity: "top",
      position: "center",
      style: {
        background: 'red',
        color: 'white'
      },
    }).showToast();

    return;
  }

  const initialButtonContent = submitButton.innerHTML;
  submitButton.disabled = true;
  submitButton.innerHTML = `<div class="spin-loader-small"></div>`;

  try {
    let response = await fetch(
      `https://photon.komoot.io/api/?q=${address}&countrycode=US`,
      {
        method: 'GET',
      }
    );

    if (!response.ok) {
      Toastify({
        text: "An error occurred while checking coverage. Please try again later.",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      submitButton.innerHTML = initialButtonContent;
      submitButton.disabled = false;
      return;
    }

    const data = await response.json();

    if (!data.features || data.features.length === 0) {
      Toastify({
        text: "Invalid address or zip code. Please try again",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      submitButton.innerHTML = initialButtonContent;
      submitButton.disabled = false;
      return;
    }

    const city = data.features[0].properties.city || '';
    const county = data.features[0].properties.county || '';
    const state = data.features[0].properties.state || '';

    const addressContent = [city, county, state].join.call([city, county, state].filter(Boolean), ', ');

    addressDisplay.innerText = addressContent;
    coverageCheckerAvailabilityPopupContainer.style.display = "flex";
    coverageCheckerAvailabilityPopup.style.display = "flex";

    submitButton.innerHTML = initialButtonContent;
    submitButton.disabled = false;
  } catch (error) {
    Toastify({
      text: "An error occurred while checking coverage. Please try again later.",
      duration: 3000,
      newWindow: true,
      gravity: "top",
      position: "center",
      style: {
        background: 'red',
        color: 'white'
      },
    }).showToast();

    submitButton.innerHTML = initialButtonContent;
    submitButton.disabled = false;
    console.error('Coverage check failed:', error);
  }
}
